
import React, { useEffect, useState } from 'react';
import { ProFormSelect, ProFormItem } from '@ant-design/pro-components';
import axiosApiInstance from '../../api/axiosClient';
import { searchParamsAtom } from '../SearchForm';
import { useAtom } from 'jotai';
import { selectAtom } from 'jotai/utils';
import { Spin } from 'antd';

type OptionType = {
    label: string;
    value: string;
};

interface DynamicSelectProps {
    name: string;
    label: string;
    rules: any[];
    placeholder: string;
    mode?: any;
    endpoint: string; // Dynamic API endpoint
    targetField: string;
}

export const DynamicSelect: React.FC<DynamicSelectProps> = ({
    name,
    label,
    rules,
    placeholder,
    mode,
    endpoint,
    targetField
}) => {
    const [SearchCriteria, setSearchCriteria] = useAtom(searchParamsAtom);

    var value: any;
    return (
        <ProFormItem name={name} rules={rules}>
            <ProFormSelect
                width={300}
                name={name}
                label={label}
                // options={options}
                placeholder={placeholder}
                mode={mode}
                showSearch={true}
                request={async () =>
                    axiosApiInstance
                        .get<OptionType[]>(`${endpoint}${new Date().getTime()}`, {
                            params: SearchCriteria
                        })
                        .then(({ data }) => data)
                }
                fieldProps={{
                    onChange(value) {
                        setSearchCriteria((prev) => {
                            prev[targetField] = value;
                            return prev;
                        });
                    }
                }}
            />
        </ProFormItem>
    );
};

export default DynamicSelect;
